import React from 'react';
import Icon from '@bd-uikit-web/React/Icon';
import UploadAreaBox from './UploadAreaBox';

export default class UploadAreaImg extends UploadAreaBox {
  constructor(props) {
    super(props);
    this._baseClass = 'upload-area upload-area--img';
    this._inlineStyles = {
      backgroundImage: `url(${props.imgSrc || ''})`,
    };

    if (props.icon) {
      this.getSymbolNode = () => (
        <div className="upload-area--img__icon">
          <Icon name={props.icon} />
        </div>
      );
    }
  }
}
